// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"RosterAssignmentDivisionBreadcrumb_breadcrumb__3UjKb","rootName":"RosterAssignmentDivisionBreadcrumb_rootName__1pkS4"};